import { Button } from "@jugl-web/ui-kit";
import { FC } from "react";

interface TicketDetailsLoadingErrorStateProps {
  onRetry: () => void;
}

export const TicketDetailsLoadingErrorState: FC<
  TicketDetailsLoadingErrorStateProps
> = ({ onRetry }) => (
  <div className="flex h-full flex-col items-center justify-center gap-8 p-6 text-center">
    <div className="flex flex-col gap-2.5">
      <h2 className="m-0 font-secondary text-xl leading-[140%] font-medium text-black">
        Oops, something went wrong
      </h2>
      <p className="m-0 font-secondary text-sm leading-[150%] font-normal text-[#828282]">
        An issue occurred while loading the ticket. Please try again.
      </p>
    </div>
    <div className="flex items-center gap-2">
      <Button onClick={onRetry} className="w-[200px]">
        Retry
      </Button>
    </div>
  </div>
);
